import { ApiBase, ApiResponse } from 'types';

export class OrderApi extends ApiBase {
  private baseURL = '/order';

  public async saveOrder(order: any): Promise<ApiResponse<any>> {
    const response = await this.apiClient.post(`${this.baseURL}/save`, order);
    return response.data;
  }

  public async getOrder(orderId: string): Promise<ApiResponse<any>> {
    const response = await this.apiClient.get(`${this.baseURL}/get?orderId=${orderId}`);
    return response.data;
  }

  public async updateOrderStatus(orderId: string, orderStatus: string): Promise<ApiResponse<any>> {
    const response = await this.apiClient.put(`${this.baseURL}/status`, { orderId, orderStatus });
    return response.data;
  }

  public async getOrderList(): Promise<ApiResponse<any>> {
    const response = await this.apiClient.get(`${this.baseURL}/all`);
    return response.data;
  }
}
